// extracted by mini-css-extract-plugin
export var base = "_2n-0";
export var updateBanner = "_2n-1";